export default __webpack_public_path__ + "static/media/yawn.82764e18.mp3";